import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import {
  useGlobalCalculatorSettings,
  FONT_SCALE_MIN,
  FONT_SCALE_MAX,
} from '../context/GlobalCalculatorSettingsContext';

/**
 * A− / A+ stepper for the shared calculator text-size preference. Reads and writes the global
 * settings context directly; the actual scaling (nudging the root rem base) is applied once at
 * the provider level, so this control just changes the value.
 */
const TextSizeControl: React.FC = () => {
  const { settings, updateSettings } = useGlobalCalculatorSettings();
  const fontScalePt = settings.fontScalePt;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', border: 1, borderColor: 'divider', borderRadius: 1 }}>
      <Tooltip title="Smaller text">
        <span>
          <IconButton
            size="small"
            onClick={() => updateSettings({ fontScalePt: fontScalePt - 1 })}
            disabled={fontScalePt <= FONT_SCALE_MIN}
            sx={{ borderRadius: 0, px: 0.75 }}
            aria-label="Decrease text size"
          >
            <Typography component="span" sx={{ fontSize: '0.8rem', fontWeight: 800, lineHeight: 1 }}>A−</Typography>
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Larger text">
        <span>
          <IconButton
            size="small"
            onClick={() => updateSettings({ fontScalePt: fontScalePt + 1 })}
            disabled={fontScalePt >= FONT_SCALE_MAX}
            sx={{ borderRadius: 0, px: 0.75 }}
            aria-label="Increase text size"
          >
            <Typography component="span" sx={{ fontSize: '1.05rem', fontWeight: 800, lineHeight: 1 }}>A+</Typography>
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default TextSizeControl;
